import { useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import { RootState } from 'appReducer'

import ReferralModal from '../../modules/referrals/ReferralModal'
import { downloadReferral, fetchReferralV2 } from '../../modules/referrals/v2actions'
import { useAppDispatch } from '../../util/useAppDispatch'
import { deleteReferral } from '../amplify/actions'
import ConfirmModal from '../shared/confirm-modal/ConfirmModal'

import './AmplifyReferral.sass'

export type AmplifyReferralActionsProps = {
    referralId: string
    v2referral: ModelsV2.Referrals.Referral
    practice: Models.Practice
    referralCreator?: Models.Account
    inboundHandler?: Models.Account
}

const AmplifyReferralActions = (props: AmplifyReferralActionsProps) => {
    const { referralId, v2referral, practice } = props
    const referral = useSelector((state: RootState) => state.v2.referrals.referralForm.referral.value)
    const account = useSelector((state: RootState) => state?.app?.self?.account)
    const primaryPatient = referral?.amplify_referral_patient?.find(patient => patient.is_primary)
    const patientFullName = `${primaryPatient?.last_name} ${primaryPatient?.first_name}`

    const [showModal, setShowModal] = useState(false)
    const [showDelete, setShowDelete] = useState(false)

    const dispatch = useAppDispatch()

    const onCloseModal = () => {
        setShowModal(false)
    }

    const onDownloadReferral = () => {
        if (referral?.id) {
            dispatch(downloadReferral(referral.id))
        }
    }

    const onShowModal = async () => {
        setShowModal(true)
        await dispatch(fetchReferralV2(referralId))
    }

    const onDeleteReferral = () => {
        setShowDelete(true)
    }

    const onRemoveDiscard = () => {
        setShowDelete(false)
    }

    return (
        <>
            <Button className="view" onClick={onShowModal}>
                View
            </Button>
            {showModal && (
                <ReferralModal
                    newTestReferral={false}
                    newManualReferral={false}
                    onClose={onCloseModal}
                    referralId={v2referral?.id}
                    onUpdate={(currentStatus, nextStatus, referralData) => {
                        onCloseModal()
                    }}
                    practice={practice}
                    account={account}
                    actions={
                        <div className="referral-actions">
                            <Button className="download amplify-referral__download-btn" onClick={onDownloadReferral}>
                                <i className="material-icons">get_app</i>
                            </Button>
                            <Button className="delete amplify-referral__download-btn" onClick={onDeleteReferral}>
                                Delete
                            </Button>
                        </div>
                    }
                />
            )}
            <ConfirmModal
                title={`Are you sure you want to remove the request for "${patientFullName}"?`}
                subtitle=""
                discardText="Cancel"
                confirmText="Remove"
                open={showDelete}
                onClose={onRemoveDiscard}
                onConfirm={() => {
                    dispatch(deleteReferral(practice.id, v2referral.id)).then(() => {
                        window.alert(`Request for '${patientFullName}' was removed.`)
                    })
                }}
                onDiscard={onRemoveDiscard}
            />
        </>
    )
}

export default AmplifyReferralActions
